import { billStatementFragment } from 'apollo/queries/autogenerate/operations';

export default function isHighPriceBill(bill: billStatementFragment) {
  return bill.outstandingAmount > 299000;
}
